import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      "max-width": "950"
    },
    model: {
      value: _vm.consulantCodeInviteModalShown,
      callback: function callback($$v) {
        _vm.consulantCodeInviteModalShown = $$v;
      },
      expression: "consulantCodeInviteModalShown"
    }
  }, [_c(VCard, {
    attrs: {
      loading: _vm.formConsultantCode.sending
    }
  }, [_c(VCardTitle, [_c("span", {
    staticClass: "text-h5 mb-4"
  }, [_vm._v("Send Invitation")])]), _c(VCardText, [_c(VForm, {
    ref: "formConsultantCode",
    model: {
      value: _vm.formConsultantCode.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.formConsultantCode, "valid", $$v);
      },
      expression: "formConsultantCode.valid"
    }
  }, [_c(VCombobox, {
    staticClass: "required",
    attrs: {
      outlined: "",
      chips: "",
      clearable: "",
      label: "To(s)",
      multiple: "",
      "append-icon": "",
      rules: [_vm.rules.mustNotBeEmpty, _vm.rules.mustBeEmails]
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          item = _ref.item;
        return [_c(VChip, _vm._b({
          attrs: {
            close: ""
          },
          on: {
            "click:close": function clickClose($event) {
              return _vm.removeConsultantFormItem(item);
            }
          }
        }, "v-chip", attrs, false), [_c("strong", [_vm._v(_vm._s(item))])])];
      }
    }]),
    model: {
      value: _vm.formConsultantCode.items,
      callback: function callback($$v) {
        _vm.$set(_vm.formConsultantCode, "items", $$v);
      },
      expression: "formConsultantCode.items"
    }
  }), _c(VTextarea, {
    attrs: {
      outlined: "",
      placeholder: "This message will be surrounded by standard invitation message.",
      "hide-details": "auto"
    },
    model: {
      value: _vm.formConsultantCode.message,
      callback: function callback($$v) {
        _vm.$set(_vm.formConsultantCode, "message", $$v);
      },
      expression: "formConsultantCode.message"
    }
  })], 1)], 1), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.formConsultantCode.sending
    },
    on: {
      click: function click($event) {
        _vm.consulantCodeInviteModalShown = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: !_vm.formConsultantCode.valid || !_vm.currentUser.id_user,
      loading: _vm.formConsultantCode.sending
    },
    on: {
      click: function click($event) {
        return _vm.sendInviteConsultantCode();
      }
    }
  }, [_vm._v(" Send ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };